import {
  IconArmchair16,
  IconBike16,
  IconCalendar16,
  IconCleaning16,
  IconDocument16,
  IconFitness16,
  IconFlipchart16,
  IconFruit16,
  IconInternet16,
  IconLocker16,
  IconOffice16,
  IconParking16,
  IconPhone16,
  IconPin16,
  IconPrint16,
  IconReception16,
  IconRenovation16,
  IconRestaurant16,
  IconSecurity16,
  IconSupport16,
  IconTea16,
  IconWiFi16,
} from '@cian/ui-kit';
// Данные иконки отсутствуют в новой версии ui-kit. Пока что берем из предыдущей, затем заменим на аналог из новой версии
import { Comments16, Fridge16 } from '@cian/ui-kit/prev/icons';

export const amenitiesIcons = {
  bike_parking: <IconBike16 />,
  cafe: <IconRestaurant16 />,
  cleaning: <IconCleaning16 />,
  events: <IconCalendar16 />,
  fax: <IconDocument16 />,
  flipchart: <IconFlipchart16 />,
  fruits: <IconFruit16 />,
  furniture: <IconOffice16 />,
  gym: <IconFitness16 />,
  internet: <IconInternet16 />,
  kitchen: <Fridge16 />,
  legal_address: <IconPin16 />,
  lockers: <IconLocker16 />,
  meeting_room: <Comments16 />,
  modern: <IconRenovation16 />,
  parking: <IconParking16 />,
  phone_booth: <IconPhone16 />,
  printer: <IconPrint16 />,
  reception: <IconReception16 />,
  rest_zone: <IconArmchair16 />,
  security: <IconSecurity16 />,
  tea: <IconTea16 />,
  tech_support: <IconSupport16 />,
  wifi: <IconWiFi16 />,
};
